import React, { useEffect } from "react";
import { ReactComponent as Close } from "svgs/close.svg";
import { ReactComponent as SearchIcon } from "svgs/fi-rs-search.svg";
import { navigate } from "gatsby";
import SearchTabs from "./tabs";
import clsx from "clsx/lite";
import { useMediaQuery } from "react-responsive";
import { SCREEN_SIZES } from "utils/constants";
import { trackSearchEnterPress } from "analytics";
import { useSettings } from "hooks/useStore";

const SearchInput = ({
	value, onChange, clear, setActiveTab, activeTab,
	toggleInputFocus, isInputFocused, variation2, isModule, embedHeader }) => {
	const { toggleSearch, toggleMenu, isSearchOpen } = useSettings(["toggleSearch", "toggleMenu", "isSearchOpen"]);
	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.sm });

	useEffect(() => {
		const handleKeyDown = event => {
			if (event.key === "Escape") toggleSearch();
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [toggleSearch]);

	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			event.preventDefault();
			if (value.trim() === "") return;
			trackSearchEnterPress(value);
			navigate(`/search?q=${value}`, { state: { activeTab } });
			if (isSearchOpen) {
				toggleSearch();
			} else {
				!isModule && toggleMenu();
			}
		}
	};

	const handleFocus = () => {
		if (!isSearchOpen && variation2) toggleSearch();
		toggleInputFocus();
	};

	const handleIconClick = (e) => {
		e.preventDefault();
		toggleSearch();
	};

	return (
		<div className={clsx("search-input-wrapper", embedHeader && "invert")}>
			<form className={clsx("search-input-container",
				(value || isInputFocused) && "border-beige md:border-black")}>
				{!variation2 && <SearchIcon />}
				<input
					className="search-input t-search-bar"
					type="search"
					placeholder={variation2 ? "What can we help you find?" : "What are you looking for?"}
					autoFocus={!isMobile && !variation2}
					value={value}
					onChange={onChange}
					onKeyDown={handleKeyDown}
					onFocus={handleFocus}
				/>
				{!variation2 && value && <button onClick={clear} className="hidden md:flex text-black animate-fadeIn">
					<Close className="size-4" />
				</button>}
				{variation2 &&
					<button className="cursor-pointer" onClick={handleIconClick}>
						<SearchIcon />
					</button>
				}
			</form>
			{!variation2 &&
				<SearchTabs
					className="hidden md:flex"
					activeTab={activeTab}
					setActiveTab={setActiveTab}
				/>
			}
		</div>
	);
};

export default SearchInput;